<template>
	<div class="quiz-question" v-if="question">
		<timer></timer>
		<div class="p-3 container" >
			<quiz-details-section :question="question"></quiz-details-section>
			<question-section :question="question" :key="question.uuid"></question-section>
			<answer-section :question="question"></answer-section>
			<next-button :question="question" :key="question.uuid"></next-button>
		</div>
	</div>
	<div v-else>
		No Question Found
	</div>
	
	<br />
	<br />
	<br />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Timer from "../helpers/Timer.vue";
import { STATE_MODULES } from "@/store/state-modules";
import { QuizGetters } from "@/store/modules/quiz/getters";
import { mapGetters } from "vuex";
import AnswerSection from '../helpers/answers/index.vue';
import NextButton from '../helpers/NextButton.vue';
import QuestionSection from '../helpers/QuestionSection.vue';
import QuizDetailsSection from '../helpers/QuizDetailsSection.vue';

export default defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			question: QuizGetters.GET_CURRENT_QUESTION
		})
	},
	components: {
		Timer, AnswerSection, NextButton, QuestionSection, QuizDetailsSection
	}
})

</script>

<style scoped>
	.container{
		max-width: 1000px;
		margin: 0 auto;
	}
</style>
